export class Subscribe {
  public Email: string="";
}
